import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useRouter } from 'shared-routing';

type ArrivalTimeForm<TArrivalTime> = UseFormReturn<{ date?: string; arrivalTime?: TArrivalTime }>;

type UseReturnToTimeWhenSlotTakenParams<TArrivalTime> = {
  form: ArrivalTimeForm<TArrivalTime>;
  id: number;
  bookingRoute: string;
  isStillOffered: (date: string, arrivalTime: TArrivalTime) => Promise<boolean>;
};

export function useReturnToTimeWhenSlotTaken<TArrivalTime>({
  form,
  id,
  bookingRoute,
  isStillOffered,
}: UseReturnToTimeWhenSlotTakenParams<TArrivalTime>) {
  const router = useRouter();

  return useCallback(async () => {
    const { date, arrivalTime } = form.getValues();
    if (!date || !arrivalTime) return;

    const offered = await isStillOffered(date, arrivalTime).catch(() => true);
    if (offered) return;

    form.setValue('date', date, { shouldTouch: true });
    form.setValue('arrivalTime', undefined, { shouldDirty: true });
    if (router.query?.bookingStep === 'extras') {
      router.push({ pathname: bookingRoute, query: { id, bookingStep: 'availability' } });
    }
  }, [form, id, bookingRoute, isStillOffered, router]);
}
